module.exports = __webpack_public_path__ + "img/choose-03.9774eeb5.png";